<template>
  <div class="resource_geographical_layer">
    <div class="form-row">
      <div class="form-group col-12">
        <label :class="isFieldRequired('geographiclayer__display_name', formConfig.requiredFields) ? 'required' : ''">
          {{ $t('resource.geographicalDisplayName') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="geographical_display_label"
          :rules="isFieldRequired('geographiclayer__display_name', formConfig.requiredFields)"
          :name="$t('resource.geographicalDisplayName')"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="resource.geographicLayer.layertitle"
              v-sanitize
              class="form-control"
              type="text"
              @change="ressourceChanged()"
              :placeholder="$t('resource.geographicalDisplayName')"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div
      v-if="resource.isXY() && showXY"
      class="form-row"
    >
      <div class="form-group col-12">
        <label :class="isFieldRequired('column_x', formConfig.requiredFields) ? 'required' : ''">
          {{ $t('resource.XLon') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="geographical_column_x"
          :rules="isFieldRequired('column_x', formConfig.requiredFields)"
          :name="$t('resource.XLon')"
        >
          <div
            class="control"
            :class="classes"
          >
            <Multiselect
              v-if="resource.xyColumnsOptions && resource.xyColumnsOptions.length"
              data-test="resource-column-x"
              v-model="resource.column_x"
              :options="resource.xyColumnsOptions.filter(el => el !== resource.column_y)"
              select-label=""
              selected-label=""
              deselect-label=""
              :searchable="false"
              :placeholder="$t('resource.XLon')"
              @input="ressourceChanged()"
            />
            <input
              v-else
              v-model="resource.column_x"
              v-sanitize
              class="form-control"
              type="text"
              data-test="resource-column-x"
              :placeholder="$t('resource.XLon')"
              @change="ressourceChanged()"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div
      v-if="resource.isXY() && showXY"
      class="form-row"
    >
      <div class="form-group col-12">
        <label :class="isFieldRequired('column_y', formConfig.requiredFields) ? 'required' : ''">
          {{ $t('resource.YLon') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="geographical_column_y"
          :rules="isFieldRequired('column_y', formConfig.requiredFields)"
          :name="$t('resource.YLon')"
        >
          <div
            class="control"
            :class="classes"
          >
            <Multiselect
              v-if="resource.xyColumnsOptions && resource.xyColumnsOptions.length"
              data-test="resource-column-y"
              v-model="resource.column_y"
              :options="resource.xyColumnsOptions.filter(el => el !== resource.column_x)"
              select-label=""
              selected-label=""
              deselect-label=""
              :searchable="false"
              :placeholder="$t('resource.YLon')"
              @input="ressourceChanged()"
            />
            <input
              v-else
              v-model="resource.column_y"
              v-sanitize
              class="form-control"
              type="text"
              data-test="resource-column-y"
              :placeholder="$t('resource.YLon')"
              @change="ressourceChanged()"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div
      v-if="resource.isXY() && showXY"
      class="form-row"
    >
      <div class="form-group col-12">
        <label :class="isFieldRequired('crs', formConfig.requiredFields) ? 'required' : ''">
          {{ $t('resource.crs') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="geographical_display_label"
          :rules="isFieldRequired('crs', formConfig.requiredFields)"
          :name="$t('resource.crs')"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="resource.crs"
              v-sanitize
              class="form-control"
              type="text"
              data-test="resource-crs"
              :placeholder="$t('resource.crs')"
              @change="ressourceChanged()"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});


export default {
  name: 'ResourceGeographicalLayer',

  components: {
    Multiselect,
    ValidationProvider
  },

  props: {
    formConfig: {
      type: Object,
      default: () => {}
    },
    resource: {
      type: Object,
      default: () => ({})
    },
    showXY: {
      type: Boolean,
      default: ()=>true
    }
  
  },

 

  watch: {
   
  },

  created() {
    if(!this.resource.geographicLayer){
      this.$set(this.resource, 'geographicLayer', {});
    }
  },
  mounted() {
    

  },
  
  methods: {
    ressourceChanged(){
      this.resource.dirty=true;
    }
  }

};
</script>